import React from 'react'

import Image from '@/assets/images/elements/image.svg'

const ImageElement = props => {
  const { attributes, styles, text } = props.item.content

  return (
    <React.Fragment>
      <img 
        src={attributes.src || Image}
        alt={text}
        style={styles}
      />
    </React.Fragment>
  )

}

export {
  ImageElement
}


// WEBPACK FOOTER //
// ./src/components/commons/editor/ImageElement.js